window.emailFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="mailto:'+value+'" rel="nofollow">'+value+'</a>';
    }
    return html;
};
